import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Rest from "../../services/Rest";


const initialState = {
    loginUsuario: {
        user: "",
        password: ""
    },
    error: false,
    message: ""
}



export default class Login extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...initialState }


    componentDidMount() {

    }


    handleChange = (e) => {
        this.setState({
            loginUsuario: {
                ...this.state.loginUsuario,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmit = e => {
        e.preventDefault();
        //extraer
        const { user, password } = this.state.loginUsuario;
        //validar
        if (user === "" || password === "") {
            this.setState({
                error: true,
                message: "Los campos usuario y contraseña son obligatorios."
            })
            return;
        }
        this.validarUsuario();
    }


    validarUsuario() {
        this.refs.btnLogin.setAttribute('disabled', 'disabled');
        this.refs.btnLogin.innerHTML = 'Iniciando...';
        let base64 = require("base-64");
        let token = base64.encode(this.state.loginUsuario.user + ":" + this.state.loginUsuario.password);
        this.Rest.login('autenticacion', token)
            .then(response => {
                if (response.status === 200) {
                    localStorage.setItem('ls', JSON.stringify(response.data))
                    this.props.parentCallBack(true);
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            message: response.message
                        })
                        this.refs.btnLogin.removeAttribute('disabled');
                        this.refs.btnLogin.innerHTML = 'Entrar';
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    message: "Error: " + err
                })
                this.refs.btnLogin.removeAttribute('disabled');
                this.refs.btnLogin.innerHTML = 'Entrar';
            })
    }

    render() {
        const { error, message } = this.state

        return (<Fragment>
            <section>
                <div className="form-login-container" > {error ? <div className="alert alert-danger" > {message} </div> : null}
                    <form onSubmit={this.handleSubmit} autoComplete="off">
                        <div className="form-group">
                            <label> Usuario </label>
                            <input
                                type="text"
                                name="user"
                                id="user"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.loginUsuario.usuario} autoComplete="off"
                            /> </div>
                        <div className="form-group">
                            <label > Contraseña  </label>
                            <input
                                type="password"
                                name="password"
                                id="password"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.loginUsuario.contrasena}
                            /> </div>
                        <button className="btn btn-primary"
                            type="submit"
                            ref="btnLogin">Entrar</button>
                    </form>
                    <div className="mt-5">
                        <ul className="list-inline">
                            <li className="list-inline-item wc-50">

                                <small > < Link to="/registrarse" > Registrarse </Link></small >

                            </li>
                            <li className="list-inline-item" >
                                <small> < Link to="/recuperar" > Recuperar contraseña </Link></small >
                            </li> </ul>
                    </div> </div>
            </section>
        </Fragment >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/main/Login.js